import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconChevronRight } from "@tabler/icons-react";

import ongoingCareIcon from "@/assets/explore-maatra/ongoing-care-grid-icon.svg";
import remoteFamilyIcon from "@/assets/explore-maatra/remote-family-grid-icon.svg";
import scatteredHealthIcon from "@/assets/explore-maatra/scattered-records-grid-icon.svg";
import hospitalisationIcon from "@/assets/explore-maatra/hospitalisation-grid-icon.svg";

import styles from "./ExploreMaatraGrid.module.css";

const CARDS = [
  {
    key: "ongoingCare",
    icon: ongoingCareIcon,
    gradient: "linear-gradient(93.59deg, #FEF3E6 0.4%, #FDE5EB 99.36%)",
    route: "/explore-maatra/ongoing-care",
  },
  {
    key: "remoteFamily",
    icon: remoteFamilyIcon,
    gradient: "linear-gradient(93.59deg, #E7F5EF 0.4%, #F4EBFE 99.36%)",
    route: "/explore-maatra/remote-family",
  },
  {
    key: "scatteredHealth",
    icon: scatteredHealthIcon,
    gradient: "linear-gradient(93.59deg, #FDF9F1 0.4%, #F6EBFF 99.36%)",
    route: "/explore-maatra/scattered-records",
  },
  {
    key: "hospitalisation",
    icon: hospitalisationIcon,
    gradient: "linear-gradient(93.59deg, #F4E9FF 0.4%, #FCE3ED 99.36%)",
    route: "/explore-maatra/hospitalisation",
  },
] as const;

const ExploreMaatraGrid: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.exploreMaatraSection} data-explore-maatra-grid>
      <h2 className={styles.title}>{t("dashboard.exploreCta")}</h2>
      <p className={styles.subtitle}>
        {t("dashboard.exploreSection.subtitle")}
      </p>
      <div className={styles.gridCard}>
        <div className={styles.grid}>
          {CARDS.map(({ key, icon, gradient, route }) => (
            <button
              key={key}
              type="button"
              className={styles.card}
              style={{ background: gradient }}
              onClick={() => navigate(route)}
            >
              <div className={styles.cardTop}>
                <span className={styles.iconWrapper}>
                  <img src={icon} alt="" className={styles.icon} />
                </span>
                <span className={styles.chevronWrapper}>
                  <IconChevronRight size={16} stroke={2} color="#2A0D55" />
                </span>
              </div>
              <span className={styles.cardLabel}>
                {t(`dashboard.exploreSection.cards.${key}`)
                  .split("\n")
                  .map((line, i) => (
                    <React.Fragment key={i}>
                      {i > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExploreMaatraGrid;
